const metadata = {
  fields: [
    'id',
    'created_at',
    'updated_at',
    'created_by',
    'updated_by',
    'user_id',
    'registration_id',
    'test_track_id',
    'test_event_id',
    'date',
    'start_time',
    'end_time',
    'paper_id',
    { test_track: ['id', 'name', 'test_track_id'] },
    { test_event: ['id', 'test_event_id', 'name'] },
    { paper: ['id', 'paper_id', 'paper_smart_id', { product: ['id', 'product_id'] }] },
    {
      candidate_details: [
        'id',
        'user_id',
        'username',
        'email_id',
        'first_name',
        'last_name',
        { registrations: ['id', 'registration_id', 'paper_id'] },
      ],
    },
  ],
}

export default metadata
